import { Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DocumentModel } from 'src/app/models/document.model';
import { PerformActionAllDoneModal } from '../modals/perform-action-all-done/perform-action-all-done.modal';
import { User } from 'src/app/models/user';
import { RequestModel } from 'src/app/models/requests';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-open-all-done-modal',
  templateUrl: './open-all-done-modal.component.html',
  styleUrls: ['./open-all-done-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OpenAllDoneModalComponent {
  private _request!: RequestModel;
  @Input() set request(request: RequestModel) {
    this._request = request;
    if(Object.keys(this._request).length > 0 && !this.modalRef){
      this.openAllDoneDialog();
    }
  }
  @Input('showDownloadButton') showDownloadButton!: boolean;
  @Input('documents') documents!: DocumentModel[];
  @Input('actions') actions!: any;
  @Input('attachments') attachments!: any;
  @Input('user') user!: User;
  @Output('DownloadRequest') DownloadRequest = new EventEmitter();

  modalRef: any;

  constructor(private modalService: NgbModal) {
    // Must not be empty. It's approved by a comment.
  }

  private openAllDoneDialog() {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'md',
      backdropClass: 'completedModal-backdrop',
      windowClass: 'completedModal',
    };
    this.modalRef = this.modalService.open(PerformActionAllDoneModal, ngbModalOptions);
    (this.modalRef.componentInstance as PerformActionAllDoneModal).expireDateAsString = formatDate(this._request.expires ? this._request.expires : new Date(), "dd-MM-y HH:mm:ss zzzz", "en-US");
    (this.modalRef.componentInstance as PerformActionAllDoneModal).DownloadRequest.subscribe((event: any) => {
      this.DownloadRequest.emit(event);
    });
  }
}
